<template >
  <v-dialog v-model="dialog" max-width="305" min-width="305" persistent>
    <v-layout align-center justify-center>
      <v-card color="rgb(255,255,255)" class="pa-3">
        <v-form class="mt-2">
            <v-form-title class="headline">Add New Post</v-form-title>
          <v-autocomplete
            v-model="source"
            :items="locations"
            label="Source"
            persistent-hint
            >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition
                mode="out-in"
              >
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
          <v-autocomplete
            v-model="destination"
            :items="locations"
            label="Destination"
            persistent-hint
            >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition
                mode="out-in"
              >
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
          <v-menu
            v-model="datemenu2"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="200px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                label="Date"
                prepend-icon="event"
                readonly
                v-on="on"
                color="black"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" @input="datemenu2 = false" color="#35455c"></v-date-picker>
          </v-menu>

          <v-menu
            ref="menu"
            v-model="timemenu2"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="time"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            color="black"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="time"
                label="Time"
                prepend-icon="access_time"
                readonly
                v-on="on"
                color="black"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="timemenu2"
              v-model="time"
              full-width
              @click:minute="$refs.menu.save(time)"
              color="#35455c"
            ></v-time-picker>
          </v-menu>
          <v-layout row align-center>
            <h3 class="subheading grey--text text--darken-1 pr-3">Cab Booked</h3>
            <v-radio-group row v-model="cab_booked">
              <v-radio label="Yes" value="1" color="#35455c"></v-radio>
              <v-radio label="No" value="0" color="#35455c"></v-radio>
            </v-radio-group>
          </v-layout>
          <v-text-field v-model="accept_limit" label="Maximum Co-passengers" required color="black"></v-text-field>
          <v-layout row wrap justify-center class="mt-1">
            <v-btn @click="onback" large color="red" dark flat>Cancel</v-btn>
            <v-btn @click="onSubmit" large color="green" dark flat :loading="loading">Submit</v-btn>
          </v-layout>
        </v-form>
      </v-card>
    </v-layout>
  </v-dialog>
</template>

<script>
import firebase from "firebase";

export default {
  data() {
    return {
      locations: [
        'Campus, IIT Kanpur',
        'Kanpur Central Railway Station (CNB)',
        'Govindpuri Railway Station',
        'Kalyanpur Railway Station',
        'Kanpur Anwarganj Railway Station',
        'Jhakarkati Bus Stand',
        'Fazalganj Bus Depot (Samayshatabdi Terminal)',
        'Azad Nagar Bus Station',
        'Kanpur Airport (Chakeri)',
        'Lucknow Airport (Amausi)',
        'Z Square Mall',
        'Rave 3 Mall',
        'Rave Moti Mall',
        'South X Mall',
      ],
      uid: firebase.auth().currentUser.uid,
      name: "",
      avatar: "",
      source: "",
      destination: "",
      requests: [],
      accepted: [],
      rejected: [],
      time_posted: null,
      post_closed: false,
      cab_booked: false,
      accept_limit: null,
      date: null,
      time: null,
      
      //Temporary Data:
      loading: false,
      menu: false,
      modal: false,
      datemenu2: false,
      timemenu2: false,
      modal2: false
    };
  },
  props: {
    dialog: Boolean
  },
  methods: {
    onback: function() {
      this.$emit("hide", false);
    },

    returnName(){
      var userName = '';
      firebase
        .firestore()
        .collection("users")
        .doc(firebase.auth().currentUser.uid)
        .get()
        .then(function(doc) {
          userName = doc.data().name;
        });
      return userName;
    },

    returnAvatar(){
      var userAvatar = '';
      firebase
        .firestore()
        .collection("users")
        .doc(firebase.auth().currentUser.uid)
        .get()
        .then(function(doc) {
          userAvatar = doc.data().avatar;
        });
      return userAvatar;
    },

    datetime() {
      return new Date(this.date + "T" + this.time + ":00+05:30");
    },

    onSubmit() {
      this.loading = true;
      const db = firebase.firestore();
      var vm = this;
      firebase.firestore().collection("users").doc(firebase.auth().currentUser.uid).get()
      .then(function(doc) {
        db.collection("posts")
          .add({
            posted_by: {
              uid: vm.uid,
              name: doc.data().name,
              avatar: doc.data().avatar
            },
            source: vm.source,
            destination: vm.destination,
            date_time: vm.datetime(),
            requests: vm.requests,
            accepted: vm.accepted,
            rejected: vm.rejected,
            accept_limit: Number(vm.accept_limit),
            time_posted: new Date(Date.now()),
            cab_booked: Boolean(vm.cab_booked),
            post_closed: vm.post_closed
          })
          .then(function(docRef) {
            vm.$emit('updatePosts');
            vm.onback();
          })
          .catch(function(error) {
            vm.color="error";
            vm.text="Error Posting";
            vm.snackbar=true;
          });
      }).catch(function (error) {
        vm.color="error";
        vm.text="Error Posting";
        vm.snackbar=true;
      });
    }
  }
};
</script>